import { omit } from 'lodash'
import { useCallback, useMemo } from 'react'
import { useTranslate } from 'react-admin'
import { DISTRIBUTOR_BRAND_FILTER_KEY } from '../distributorBrand/DistributorBrandFilterNodeFactory'
import useDistributorAvailableBrands from '../distributorBrand/useDistributorAvailableBrands'
import type { ManufacturerFilterProps } from './ManufacturerFilter'
import { defaultManufacturerOption, EXHIBITOR_FILTER_KEY, MANUFACTURER_FILTER_KEY } from './ManufacturerFilter'

const DistributorBrandManufacturerFilter = ({
  disabled,
  modifiableFilterValues,
  persistentFilterValues,
  allFilterValues,
  setModifiableFilters,
  RendererComponent,
  componentType,
}: ManufacturerFilterProps) => {
  const translate = useTranslate()
  const onSelect = useCallback(
    (value) => {
      // Always clear first
      const newFilterValues = omit({ ...modifiableFilterValues }, [
        EXHIBITOR_FILTER_KEY,
        MANUFACTURER_FILTER_KEY,
        DISTRIBUTOR_BRAND_FILTER_KEY,
      ])

      if (value === '') {
      } else if (value !== '') {
        newFilterValues[DISTRIBUTOR_BRAND_FILTER_KEY] = value
      }
      setModifiableFilters(newFilterValues)
    },
    [modifiableFilterValues]
  )

  const selectedDistributor = useMemo(() => {
    switch (allFilterValues['require_distributor']) {
      case 'outlet':
        return 'outlet'
      case 'city_plumbing':
        return 'city_plumbing'
      default:
        return undefined
    }
  }, [allFilterValues['require_distributor']])

  const availableBrands = useDistributorAvailableBrands({
    distributor: selectedDistributor,
    componentType: componentType,
  })

  const options = useMemo(() => {
    const translatedDefaultOption = { ...defaultManufacturerOption, title: translate('All') }
    return availableBrands.sort().reduce(
      (options, brand) => {
        return options.concat({ id: brand, value: encodeURIComponent(brand), title: brand })
      },
      [translatedDefaultOption]
    )
  }, [availableBrands, translate])

  const value =
    allFilterValues[DISTRIBUTOR_BRAND_FILTER_KEY] !== undefined ? allFilterValues[DISTRIBUTOR_BRAND_FILTER_KEY] : ''

  return (
    <RendererComponent
      id={'manufacturer_filter'}
      defaultValue={''}
      label={translate('Manufacturer')}
      options={options}
      disabled={!!disabled}
      onSelect={onSelect}
      value={value}
    />
  )
}

export default DistributorBrandManufacturerFilter
